import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReplicateInformationRoutingModule } from './replicate-information-routing.module';
import { ReplicateInformationComponent } from './replicate-information.component';
import { ListReplicateInformationModule } from './list-replicate-information/list-replicate-information.module';
import { ReplicateInformationDetailsModule } from './replicate-information-details/replicate-information-details.module';


@NgModule({
  declarations: [
    ReplicateInformationComponent
  ],
  imports: [
    CommonModule,
    ListReplicateInformationModule,
    ReplicateInformationRoutingModule,
    ReplicateInformationDetailsModule
  ],
  exports: [ReplicateInformationComponent]
})
export class ReplicateInformationModule { }
